export default "__VITE_ASSET__d03426d9__"